import EL, { HTMLELEMENT } from '../../../../EL/EL.js';
import TGROUP from '../../../../DOM/table/TGROUP/TGROUP.js';
import THEAD from '../../../../DOM/table/TGROUP/THEAD.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import GROUP from '../../../../DOM/GROUP/GROUP.js';
import COLUMNFACTORY, { factoryModel } from '../../../../DOM/table/TGROUP/ROW/COLUMNFACTORY.js';
// Model Structure
export const trAttr = makeAttrStruct([
    ['class'],
    ['id'],
    ['name']
]);
export const trData = makeDataStruct([
    ['columns', []]
]);
export const trModel = makeStruct([
    ['attributes', trAttr],
    ['data', trData]
]);
/** A TR (Table Row) that exists inside a table */
export default class TR extends GROUP {
    constructor(node, model) {
        super(node, HTMLELEMENT.TR, model);
        this.addClass('table-row');
        this.columnFactory = new COLUMNFACTORY(factoryModel(), this);
    }
    activateEvent() {
        let cols = this.getColumns();
        console.log('Activated TR', this.getTGroup(), cols);
    }
    // /** Retrieves an array of columns inside this row */
    // getColumns(): COLUMN<ColumnElementModel>[] {
    // 	return this.get(null, this.getColType());
    // }
    /** Determines the appropriate COLUMN Element based on its parent class */
    getColType() {
        return this.getTGroup().className === 'TBODY' ? 'TD' : 'TH';
    }
    // /** Returns an array of columns that have the 'active' class */
    // getActiveColumns(): COLUMN<ColumnElementModel>[] {
    // 	return this.getColumns().filter((c) => c.hasClass('active'));
    // }
    /** Adds a Column to this TR */
    addColumn(model) {
        let col;
        if (this.node instanceof THEAD) {
            //col = this.addChild(new TH(this, model)) as I;
            col = this.columnFactory.create('TH', model);
        }
        else {
            //col = this.addChild(new TD(this, model)) as I;
            col = this.columnFactory.create('TD', model);
        }
        return col;
    }
    /** Returns this row's table-group (THEAD|TBODY|TFOOT) */
    getTGroup() {
        return this.node;
    }
}
export { EL, TGROUP };
